import React, { useEffect, useState } from 'react';
import { ParlaySelection } from '../../../../models/MyBetModel';
import { useBetContext } from '../../../../context/ParlayBetContext.tsx';
import { formatSpecialtyMarketLabel, getDisplayBetInfo, getBetSpecialtyMarketLabel, preferPrimarySportsbookOdds } from '../../../../helpers/functions.tsx';
import BetLogo from '../BetLogo.tsx';
import { BetSlipTrashButton, SlipOddStepper } from '../BetSlipChrome.tsx';

interface ITeamOdd {
    bet: ParlaySelection
}

const TeamOdd = (props: ITeamOdd) => {

    const { bet } = props;
    const { updateBetTeaser, deleteBet } = useBetContext();
    const [odd, setOdd] = useState(bet.odd);

    useEffect(() => {
        const preferred = preferPrimarySportsbookOdds(bet.odds?.length ? bet.odds : (bet.odd ? [bet.odd] : []));
        const next = preferred.find(item => item.id === bet.odd?.id) ?? preferred[0] ?? bet.odd;
        setOdd(prev => (prev?.id === next?.id ? prev : next));
    }, [bet]);

    useEffect(() => {
        const updatedBet: ParlaySelection = { ...bet, odd, id: odd?.id, betName: odd?.name, marketName: odd?.market };
        updateBetTeaser(updatedBet);
    }, [odd]);

    const { name: displayBetName } = getDisplayBetInfo(bet);
    const oddsList = preferPrimarySportsbookOdds(bet.odds?.length ? bet.odds : (odd ? [odd] : []));
    const marketLabel = getBetSpecialtyMarketLabel(bet) || formatSpecialtyMarketLabel(bet.marketName);

    return (
        <div className="sq-confirm__group-leg">
            <BetLogo bet={bet} className="sport-logos-modal" alt="" />
            <div className="sq-slip__pick-meta">
                <span className="sq-slip__pick-name">{displayBetName}</span>
                <span className="sq-slip__pick-market">{marketLabel || 'Teaser Selection'}</span>
            </div>
            <div className="sq-confirm__leg-odds">
                {oddsList.length > 0 && (
                    <SlipOddStepper
                        odds={oddsList}
                        value={odd?.id}
                        marketName={bet.marketName}
                        onSelect={setOdd}
                        pointsOnly
                    />
                )}
                <BetSlipTrashButton onClick={() => deleteBet(bet)} />
            </div>
        </div>
    );
};

export default TeamOdd
